enum OEMeetingRecordType {
  URL = 'URL',
  VIDEO_FILE = 'FILE',
}

export default OEMeetingRecordType;
